export var MenuTypes = {
    Geo: 'geo',
    Newspaper: 'newspaper_subscription',
    Pta: 'pta',
    Automobile: 'automobile',
    Mansion: 'mansion',
    GeoGenome: 'geo_genome',
    Railway: 'railway',
    Retargeting: 'retargeting',
    CustomGeo: 'custom_geo',
    Office: 'office',
    Custom: 'custom',
};
export var RailwayCategoryTypes = {
    Company: 'company',
    Line: 'line',
    Station: 'station',
};
export var RailwayTargetTypes = {
    Route: 'route',
    Commuting: 'commuting',
    Passenger: 'passenger',
    Station: 'station',
};
export var Clusters = [
    { id: 1, name: '都心の高層マンションセレブ' },
    { id: 2, name: '都心の若者ひとり暮らし' },
    { id: 3, name: '若手キャリア系ビジネスマン' },
    { id: 4, name: '都心へ通勤独身貴族' },
    { id: 5, name: '都会の勝ち組ファミリー' },
    { id: 6, name: '都会のニューファミリー' },
    { id: 7, name: '超高級住宅地のエグゼクティブ' },
    { id: 8, name: '中高年ファミリーの持ち家高級住宅街' },
    { id: 9, name: '都会の新興高級マンション' },
    { id: 10, name: '育児ニュータウンマンション' },
    { id: 11, name: 'お手ごろニュータウン' },
    { id: 12, name: '子育てマイホーム' },
    { id: 13, name: '高齢化の進むニュータウン' },
    { id: 14, name: 'ひとり暮らしの都市労働者' },
    { id: 15, name: '繁華街の貧困地区' },
    { id: 16, name: '低所得の外国人居住区' },
    { id: 17, name: '念願の一戸建て' },
    { id: 18, name: '近郊高層マンションで子育て' },
    { id: 19, name: '大都市近郊の中流ファミリー' },
    { id: 20, name: '下町' },
    { id: 21, name: '団地' },
    { id: 22, name: '地方都市駅前の若者ひとり暮らし' },
    { id: 23, name: '地方都市駅近く' },
    { id: 24, name: '地方都市の中流世帯' },
    { id: 25, name: '地方都市のエリート' },
    { id: 26, name: '地方都市の賃貸組' },
    { id: 27, name: '地方の観光地・中小都市' },
    { id: 28, name: '工場勤めの子育てファミリー' },
    { id: 29, name: '工場勤めの一軒家大家族' },
    { id: 30, name: '工場勤めの高齢夫婦' },
    { id: 31, name: '農家の大家族' },
    { id: 32, name: '超高齢化が進む農村' },
    { id: 33, name: '大学生の街' },
    { id: 34, name: '公務員の街・研究都市' },
    { id: 35, name: '病院・大学教員のひとり暮らし寮' },
    { id: 36, name: '自衛隊の寮' },
];
export var OfficeListedOptions = [
    { name: '東証プライム', key: 8, isReadOnly: false, order: 1 },
    { name: '東証スタンダード', key: 9, isReadOnly: false, order: 2 },
    { name: '地方上場', key: 5, isReadOnly: false, order: 3 },
    { name: '東証グロース', key: 10, isReadOnly: false, order: 4 },
    { name: '非上場', key: 7, isReadOnly: false, order: 5 },
];
export var DeprecatedOfficeListedOptions = [
    { name: '東証一部', key: 1, order: 99 },
    { name: '東証二部', key: 2, order: 99 },
    { name: 'JASDAQ', key: 3, order: 99 },
    { name: 'マザーズ', key: 4, order: 99 },
    { name: 'ヘラクレス', key: 6, order: 99 },
];
